import { render, staticRenderFns } from "./HistoryForm.vue?vue&type=template&id=34481e42&scoped=true&lang=pug&"
import script from "./HistoryForm.vue?vue&type=script&lang=js&"
export * from "./HistoryForm.vue?vue&type=script&lang=js&"
import style0 from "./HistoryForm.vue?vue&type=style&index=0&id=34481e42&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34481e42",
  null
  
)

export default component.exports